import React, { forwardRef } from "react";
import classnames from "classnames";
import Reflux from "reflux";
import axios from "axios";
import { customAlphabet } from "nanoid";

import {
  Card,
  Container,
  Row,
  CardTitle,
  CardBody,
  Label,
  FormGroup,
  Input,
  FormText,
  Form,
  Col,
  Button,
  Modal,
  ButtonGroup,
  UncontrolledTooltip,
  CardHeader,
  Collapse,
  FormFeedback,
} from "reactstrap";

// core components
import Header from "../../components/Headers/Header";

import { withApollo } from "react-apollo";

import moment from "moment";
import "moment/locale/es";

import ReactBSAlert from "react-bootstrap-sweetalert";

import { UserStore } from "../../store/UserStore";
//import memoize from 'memoize-one';

// JavaScript library that creates a callendar with events
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interaction from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import uuid from "react-uuid";
// react component used to create sweet alerts
import esLocale from "@fullcalendar/core/locales/es";
//import "@fullcalendar/timegrid/main.css";

import "../../assets/vendor/fullcalendar/dist/fullcalendar.min.css";

var DatePicker = require("reactstrap-date-picker");

const spanishDayLabels = ["Dom", "Lu", "Ma", "Mi", "Ju", "Vi", "Sab"];
const spanishMonthLabels = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
const alphabet = "0123456789";
class eventos extends Reflux.Component<any, any> {
  public maxFileSize = 3;
  public fileInput: any = null;
  public lecturasRef: any = [];
  public inputEl: any = null;
  public formRef: any = null;
  lastFilters = {};
  state = {
    filters: {
      eventoDesde: "",
      eventoHasta: "",
      comercial: "",
      estado: "",
    },
    UserStore: {},
    nombreFichero: "",
    isLoading: false,
    copiedText: null,
    currentPage: 0,
    pageSize: 0,
    pageCount: 0,
    count: 0,
    contrato: "",
    tipoContrato: "",
    errores: {
      eventoDesde: true,
      eventoHasta: true,
      comercial: true,
      estado: true,
    },
    textErrores: {
      identificacionEmpresa: "",
      nombreComercial: "SIN DATOS",
      correoComercial: "SIN DATOS",
      apellido1Comercial: "SIN DATOS",
      NIFComercial: "SIN DATOS",
      password: "SIN DATOS",
      companyId: "",
    },
    companyIdUser: "",
    companyNameGlobal: "",
    userGroupId: 1000,
    userId: "",

    saveDataComercial: false,
    updateDataComercial: false,
    saveComercialButtonDisabled: true,
    updateComercialButtonDisabled: true,
    buscarButtonDisabled: true,
    show: false,
    imgCollection: [],
    uploadButtonDisabled: true,
    showFilters: true,
    toggledClearRows: false,
    locale: "es",
    createdAt: "",
    fechaBaja: "",
    codigoPostalComercialError: false,
    dicMunicipios: [],
    alert: null,
    openModalComparative: false,
    empresaSeleccionada: [],
    licenciasTotal: {
      totalLicencias: 0,
      usuariosActivos: 0,
      usuariosNoActivo: 0,
    },
    propuestaEvento: null,
    comercializadoraEvento: null,
    nifEvento: null,
    empresaEvento: null,
    comercializadoraEventoDescripcion: null,
    fechaDesdeEvento: null,
    fechaHastaEvento: null,
    eventoDesde: "",
    eventoHasta: "",
    startDate: "",
    endDate: "",
    eventTitle: "",
    radios: "bg-info",
    eventDescription: "",
    clienteModal: "",
    propuestaModal: "",
    events: [
      {
        title: "",
        start: "",
        end: "",
        className: "",
        id: "",
        description: "",
        allDay: true,
        extendedProps: {
          idComercial: null,
          comercial: "",
          tipoDocumento: "",
          tipoEnergia: "",
          idCliente: "",
          nombreCliente: "",
          propuestaIdEvento: "",
          propuestaNombreEvento: "",
          propuestaFechaInicioEvento: "",
          estado: "",
          idEstado: "",
        },
      },
    ],
    usuariosPropuestas: [
      {
        email: "SIN DATOS",
        first_name: "SIN DATOS",
        id: 0,
        last_name: "SIN DATOS",
        query_limit: 0,
        user_group_id: 0,
      },
    ],
    clientesPropuestas: [
      {
        id: 0,
        NIF: "SIN DATOS",
        NombreTitular: "",
        Apellido1Titular: "",
      },
    ],
    comerListDisabled: false,
    comerGasListDisabled: false,
    comerListDisabledEvento: false,
    comerGasListDisabledEvento: false,
    propuestasListDisabledEvento: false,
    contratosListDisabledEvento: false,
    estadoDescripcion: "",

    codeele: "",
    codegas: "",
    propuestaIdEvento: "",
    propuestaNombreEvento: "",
    propuestaFechaInicioEvento: "",
    clienteEvento: "",
    nifClienteEvento: "",
    modalChange: false,
    tipoEnergia: "",
    tipoDocumento: "",
    eventoAux: {
      comercial: "",
      idComercial: "",
      NIF: "",
      radios: "",
      tipoEnergia: "",
      tipoDocumento: "",
      nombreCliente: "",
      estado: "",
      idEstado: "",
    },
    propuestasListado: [
      {
        IdOferta: "",
        nombreOferta: "",
        fechaPropuesta: "",
        tipoEnergia: "",
        T_Titular: {
          NIF: "",
          NombreTitular: "",
          Apellido1Titular: "",
        },
      },
    ],
    contratosListado: [
      {
        IdContrato: "",
        nombreOferta: "",
        fechaInicioContrato: "",
        tipoEnergia: "",
        T_Titular: {
          NIF: "",
          NombreTitular: "",
          Apellido1Titular: "",
        },
      },
    ],
    estadosEvento: [
      {
        estado: "INFORMACION",
        idEstado: "30",
      },
      {
        estado: "PENDIENTE",
        idEstado: "40",
      },
      {
        estado: "INCIDENCIA",
        idEstado: "50",
      },
      {
        estado: "OTROS",
        idEstado: "60",
      },
      {
        estado: "CERRADO",
        idEstado: "90",
      },
    ],
  };

  constructor(props) {
    super(props);
    this.store = UserStore;
    this.formRef = React.createRef();
  }

  UNSAFE_componentWillReceiveProps() {
    const usuario: any = JSON.parse(
      JSON.stringify(this.state.UserStore["data"])
    );
    const companyNameGlobal = usuario.company;
    const companyIdUser = usuario.companyId;
    const userGroupId = usuario.user_group_id;
    const userId = usuario.id;

    if (userGroupId === 1000) {
      this.setState({
        activeUser: true,
      });
    }

    this.setState({
      companyNameGlobal,
      companyIdUser,
      userGroupId,
      userId,
    });
  }

  UNSAFE_componentWillMount() {

    let companyIdUser = "";
    let companyNameUser = "";
    let companyNameGlobal = "";
    let userGroupId = "";
    let userId = "";
    let userName = "";

    const userFromStorage = localStorage.getItem("user");
    if (userFromStorage) {
      try {
        const parsed = JSON.parse(userFromStorage);
        companyIdUser = parsed.companyId;
        companyNameUser = parsed.company;
        companyNameGlobal = parsed.company;
        userGroupId = parsed.user_group_id;
        userId = parsed.id;
        userName = parsed.fullname;
      } catch (e) {
        console.log(e);
      }
    }
    this.setState({
      companyIdUser,
      companyNameUser,
      companyNameGlobal,
      userGroupId,
      userId,
      userName,
    });
  }

  componentDidMount() {
    const usuario: any = JSON.parse(
      JSON.stringify(this.state.UserStore["data"])
    );

    const {
      match: { params },
    } = this.props;

    var eventoAux = { ...this.state.eventoAux };
    let companyIdUser = "";
    let companyNameUser = "";
    let companyNameGlobal = "";
    let userGroupId = "";
    let userId = "";
    let userName = "";
    let first_name = "";
    let last_name = "";

    const userFromStorage = localStorage.getItem("user");
    if (userFromStorage) {
      try {
        const parsed = JSON.parse(userFromStorage);
        companyIdUser = parsed.companyId;
        companyNameUser = parsed.company;
        companyNameGlobal = parsed.company;
        userGroupId = parsed.user_group_id;
        userId = parsed.id;
        userName = parsed.fullname;
        first_name = parsed.first_name;
        last_name = parsed.last_name;
      } catch (e) {
        console.log(e);
      }
    }

    if (Number(userGroupId) < 500) {
      eventoAux["idComercial"] = userId;
      eventoAux["comercial"] = last_name + " " + first_name;
    } else {
      eventoAux["idComercial"] = "";
      eventoAux["comercial"] = "";
    }

    this.setState({
      companyIdUser,
      companyNameUser,
      companyNameGlobal,
      userGroupId,
      userId,
      userName,
      eventoAux: eventoAux,
    });

    this.usuariosPermitidos();
    this.clientesPermitidos();
  }

  /////////////////////////////////////////////////////////////////////////////

  usuariosPermitidos = async () => {
    const userFromStorage: any = localStorage.getItem("user");
    const parsed = JSON.parse(userFromStorage);

    var companyIdUser = parsed.companyId;
    var user = Number(parsed.id);
    var userQuery = parsed.id;
    var user_group_id = parsed.user_group_id;

    var dataFilters = {
      id: userQuery,
      user_group_id: user_group_id,
    };

    if (user_group_id > 400) {
      dataFilters = {
        id: null,
        user_group_id: user_group_id,
      };
    }

    const valores = JSON.stringify(dataFilters);
    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/usuario/usuariospermitidos?id=" +
      companyIdUser +
      "&user=" +
      user;
    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        if (result) {
          let data = result.data;
          this.setState({ usuariosPropuestas: data });
        }
      })
      .catch((error) => {
        console.log("Failure");
      });
  };

  /////////////////////////////////////////////////////////////////////////////

  clientesPermitidos = async () => {
    const userFromStorage: any = localStorage.getItem("user");
    const parsed = JSON.parse(userFromStorage);

    var companyIdUser = parsed.companyId;
    var user = Number(parsed.id);
    var userQuery = parsed.id;
    var user_group_id = parsed.user_group_id;

    var dataFilters = {
      id: userQuery,
    };

    if (user_group_id > 400) {
      dataFilters = {
        id: null,
      };
    }

    const valores = JSON.stringify(dataFilters);
    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/cliente/clientespermitidos?id=" +
      companyIdUser +
      "&user=" +
      user;
    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        if (result) {
          let data = result.data.rows;
          this.setState({ clientesPropuestas: data });
        }
      })
      .catch((error) => {
        console.log("Failure");
      });
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  async getcalendarioList() {
    const user: any = localStorage.getItem("user");
    var datosUser: any = [];
    if (user) {
      datosUser = JSON.parse(user);
      //this.setState({ user: parsed });
    }
    var iduserProceso = datosUser.id ? datosUser.id : "";
    var idEmpresaProceso = datosUser.companyId ? datosUser.companyId : "";

    var datosFilters: any = this.state.filters;

    let eventoDesde = datosFilters.eventoDesde;
    let eventoHasta = datosFilters.eventoHasta;

    if (datosFilters.eventoDesde && !datosFilters.eventoHasta) {
      let start = new Date(eventoDesde);
      let end = new Date(start);
      end.setMonth(end.getMonth() + 3);
      eventoHasta = end.toISOString();
    } else if (!datosFilters.eventoDesde && datosFilters.eventoHasta) {
      let start = new Date(eventoHasta);
      let end = new Date(start);
      end.setMonth(end.getMonth() - 3);
      eventoDesde = end.toISOString();
    } else if (!datosFilters.eventoDesde && !datosFilters.eventoHasta) {
      let now = new Date();
      let start = new Date(now);

      start.setMonth(start.getMonth() - 3);
      eventoDesde = start.toISOString();

      let end = new Date(now);
      end.setMonth(end.getMonth() + 5);
      eventoHasta = end.toISOString();
    }

    var dataFilters = {
      start: eventoDesde,
      end: eventoHasta,
      idComercial: datosFilters.comercial,
      idEstado: datosFilters.estado,
    };

    const valores = JSON.stringify(dataFilters);

    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "Content-Type": "application/json",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };

    let direccionFile =
      "https://datapi.psgestion.es/eventos/lista?id=" +
      idEmpresaProceso +
      "&user=" +
      iduserProceso;

    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        var events = result.data.rows;

        this.setState({
          events: events,
          filters: {
            eventoDesde: "",
            eventoHasta: "",
            comercial: "",
            estado: "",
          },
          errores: {
            eventoDesde: true,
            eventoHasta: true,
            comercial: true,
            estado: true,
          },
        });
        this.formRef.current.reset();
        //return this.state.events
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  async insertcalendarioList(
    title,
    start,
    end,
    className,
    id,
    description,
    iduser,
    comercial,
    tipoDocumento,
    tipoEnergia,
    idCliente,
    nombreCliente,
    propuestaIdEvento,
    propuestaNombreEvento,
    propuestaFechaInicioEvento,
    estado,
    idEstado
  ) {
    const user: any = localStorage.getItem("user");
    var datosUser: any = [];
    if (user) {
      datosUser = JSON.parse(user);
      //this.setState({ user: parsed });
    }
    var iduserProceso = datosUser.id ? datosUser.id : "";
    var idEmpresaProceso = datosUser.companyId ? datosUser.companyId : "";

    var calendarioDataInsert = {};

    var titulo = title ? nombreCliente + " " + title : nombreCliente;

    calendarioDataInsert = {
      title: titulo,
      start: start,
      end: end,
      className: className,
      id: id,
      description: description,
      allDay: true,
      extendedProps: {
        idComercial: iduser,
        comercial: comercial,
        tipoDocumento: tipoDocumento,
        tipoEnergia: tipoEnergia,
        idCliente: idCliente,
        nombreCliente: nombreCliente,
        propuestaIdEvento: propuestaIdEvento,
        propuestaNombreEvento: propuestaNombreEvento,
        propuestaFechaInicioEvento: propuestaFechaInicioEvento,
        estado: estado,
        idEstado: idEstado,
      },
    };

    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "Content-Type": "application/json",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/eventos/crear?id=" +
      idEmpresaProceso +
      "&user=" +
      iduserProceso;

    axios
      .post(direccionFile, calendarioDataInsert, {
        headers,
        responseType: "json",
      })
      .then((result) => {
        console.log("Actualización correcta", result);

        let eventoAux = {
          comercial: "",
          idComercial: "",
          NIF: "",
          radios: "",
          tipoEnergia: "",
          tipoDocumento: "",
          nombreCliente: "",
          estado: "",
          idEstado: "",
        };

        this.setState({
          eventoAux: eventoAux,
          modalChange: false,
          radios: "bg-info",
          eventTitle: undefined,
          eventDescription: undefined,
          eventId: undefined,
          event: undefined,
          alert: false,
          estadoDescripcion: "",
          clienteEvento: "",
          nifClienteEvento: "",
          propuestaIdEvento: "",
          propuestaNombreEvento: "",
          propuestaFechaInicioEvento: "",
          tipoEnergia: "",
          tipoDocumento: "",
          start: "",
          end: "",
          clienteModal: "",
          propuestaModal:"",
          filters: {
            eventoDesde: "",
            eventoHasta: "",
            comercial: "",
            estado: "",
          },
          errores: {
            eventoDesde: true,
            eventoHasta: true,
            comercial: true,
            estado: true,
          },
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  async updatecalendarioList(evento) {
    const user: any = localStorage.getItem("user");
    var datosUser: any = [];
    if (user) {
      datosUser = JSON.parse(user);
    }
    var iduserProceso = datosUser.id ? datosUser.id : "";
    var idEmpresaProceso = datosUser.companyId ? datosUser.companyId : "";

    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "Content-Type": "application/json",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/eventos/actualizar?id=" +
      idEmpresaProceso +
      "&user=" +
      iduserProceso;

    axios
      .post(direccionFile, evento, { headers, responseType: "json" })
      .then((result) => {

        let eventoAux = {
          comercial: "",
          idComercial: "",
          NIF: "",
          radios: "",
          tipoEnergia: "",
          tipoDocumento: "",
          nombreCliente: "",
          estado: "",
          idEstado: "",
        };

        this.setState({
          eventoAux: eventoAux,
          modalChange: false,
          radios: "bg-info",
          eventTitle: undefined,
          eventDescription: undefined,
          eventId: undefined,
          event: undefined,
          alert: false,
          estadoDescripcion: "",
          clienteEvento: "",
          nifClienteEvento: "",
          propuestaIdEvento: "",
          propuestaNombreEvento: "",
          propuestaFechaInicioEvento: "",
          tipoEnergia: "",
          tipoDocumento: "",
          start: "",
          end: "",
          clienteModal: "",
          propuestaModal:"",
          filters: {
            eventoDesde: "",
            eventoHasta: "",
            comercial: "",
            estado: "",
          },
          errores: {
            eventoDesde: true,
            eventoHasta: true,
            comercial: true,
            estado: true,
          },
        });
        //this.clearForm();
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  async deletecalendarioList(borrarEvento) {
    const user: any = localStorage.getItem("user");
    var datosUser: any = [];
    if (user) {
      datosUser = JSON.parse(user);
      //this.setState({ user: parsed });
    }
    var iduserProceso = datosUser.id ? datosUser.id : "";
    var idEmpresaProceso = datosUser.companyId ? datosUser.companyId : "";

    var calendarioDataDelete = {};

    var idEvento = borrarEvento;

    calendarioDataDelete = {
      userId: iduser,
      id: idEvento,
    };

    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "Content-Type": "application/json",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/eventos/delete?id=" +
      idEmpresaProceso +
      "&user=" +
      iduserProceso;

    axios
      .post(direccionFile, calendarioDataDelete, {
        headers,
        responseType: "json",
      })
      .then((result) => {

        let eventoAux = {
          comercial: "",
          idComercial: "",
          NIF: "",
          radios: "",
          tipoEnergia: "",
          tipoDocumento: "",
          nombreCliente: "",
          estado: "",
          idEstado: "",
        };

        this.setState({
          eventoAux: eventoAux,
          modalChange: false,
          radios: "bg-info",
          eventTitle: undefined,
          eventDescription: undefined,
          eventId: undefined,
          event: undefined,
          alert: false,
          estadoDescripcion: "",
          clienteEvento: "",
          nifClienteEvento: "",
          propuestaIdEvento: "",
          propuestaNombreEvento: "",
          propuestaFechaInicioEvento: "",
          tipoEnergia: "",
          tipoDocumento: "",
          start: "",
          end: "",
          clienteModal: "",
          propuestaModal:"",
          filters: {
            eventoDesde: "",
            eventoHasta: "",
            comercial: "",
            estado: "",
          },
          errores: {
            eventoDesde: true,
            eventoHasta: true,
            comercial: true,
            estado: true,
          },
        });
        //this.clearForm();
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
        });
      });
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  changeEvent = () => {
    var idCambio = "";
    var newEvents = this.state.events.map((prop, key) => {
      if (prop.id + "" === this.state.eventId + "") {
        this.state.event.remove();
        idCambio = prop.id;
        return {
          ...prop,
          title: this.state.eventTitle,
          className: this.state.radios,
          description: this.state.eventDescription,
        };
      } else {
        return prop;
      }
    });

    newEvents.map((prop, key) => {
      if (prop.id + "" === idCambio + "") {
        this.updatecalendarioList(prop);
      }
    });

    this.setState({
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined,
      alert: false,
      eventoAux: {
        comercial: "",
        idComercial: "",
        NIF: "",
        radios: "",
        tipoEnergia: "",
        tipoDocumento: "",
        nombreCliente: "",
        estado: "",
        idEstado: "",
      },
      clienteEvento: "",
      estadoDescripcion: "",
      nifClienteEvento: "",
      propuestaIdEvento: "",
      propuestaNombreEvento: "",
      propuestaFechaInicioEvento: "",
      tipoEnergia: "",
      tipoDocumento: "",
      start: "",
      end: "",
      clienteModal: "",
      propuestaModal:"",
    });
  };

  deleteEventSweetAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="¿Estás seguro?"
          onConfirm={() =>
            this.setState({
              alert: false,
              radios: "bg-info",
              eventTitle: undefined,
              eventDescription: undefined,
              eventId: undefined,
              eventoAux: {
                comercial: "",
                idComercial: "",
                NIF: "",
                radios: "",
                tipoEnergia: "",
                tipoDocumento: "",
                nombreCliente: "",
                estado: "",
                idEstado: "",
              },
              clienteEvento: "",
              estadoDescripcion: "",
              nifClienteEvento: "",
              propuestaIdEvento: "",
              propuestaNombreEvento: "",
              propuestaFechaInicioEvento: "",
              tipoEnergia: "",
              tipoDocumento: "",
              start: "",
              end: "",
            })
          }
          onCancel={() => this.deleteEvent()}
          confirmBtnCssClass="btn-secondary"
          cancelBtnBsStyle="danger"
          confirmBtnText="Cancelar"
          cancelBtnText="Si, bórralo"
          showCancel
          btnSize=""
        >
          Una vez realizada la acción no se podrá recuperar!
        </ReactBSAlert>
      ),
    });
  };

  deleteEvent = () => {
    var newEvents = this.state.events.filter(
      (prop) => prop.id + "" !== this.state.eventId
    );

    var borrarEvento = this.state.eventId;

    this.state.event.remove();

    this.deletecalendarioList(borrarEvento);

    this.setState({
      modalChange: false,
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined,
      eventoAux: {
        comercial: "",
        idComercial: "",
        NIF: "",
        radios: "",
        tipoEnergia: "",
        tipoDocumento: "",
        nombreCliente: "",
        estado: "",
        idEstado: "",
      },
      clienteEvento: "",
      estadoDescripcion: "",
      nifClienteEvento: "",
      propuestaIdEvento: "",
      propuestaNombreEvento: "",
      propuestaFechaInicioEvento: "",
      tipoEnergia: "",
      tipoDocumento: "",
      start: "",
      end: "",
      clienteModal: "",
      propuestaModal:"",
    });
  };

  onChangeModalEvento = (event) => {
    event.persist();

    const name = event.target.name;
    let value = event.target.value;
    var cliente = "";
    var propuesta = "";
    var fechaPropuesta = "";
    var tipoDocumento = "";
    var tipoEnergia = "";
    const camposBusqueda = ["IdCliente"];
    const camposBusquedaContrato = ["IdCliente"];

    var eventoAux = { ...this.state.eventoAux };

    if (event.target.name === "IdCliente") {
      let indexCliente = this.state.clientesPropuestas.findIndex(
        (object) => object.NIF === value
      ); // 👉️ 1

      if (indexCliente !== -1) {
        cliente =
          this.state.clientesPropuestas[indexCliente].NombreTitular +
          " " +
          this.state.clientesPropuestas[indexCliente].Apellido1Titular;
      }
      var idCliente = value;
      var clienteEvento = cliente;

      eventoAux["NIF"] = value;
      eventoAux["nombreCliente"] = cliente;

      this.setState({
        clienteEvento: clienteEvento,
        nifClienteEvento: idCliente,
      });
    }

    if (event.target.name === "IdOferta") {
      let indexPropuesta = this.state.propuestasListado.findIndex(
        (object) => object.IdOferta === value
      ); // 👉️ 1

      if (indexPropuesta !== -1) {
        propuesta = this.state.propuestasListado[indexPropuesta].nombreOferta;
        fechaPropuesta =
          this.state.propuestasListado[indexPropuesta].fechaPropuesta;
        tipoEnergia = this.state.propuestasListado[indexPropuesta].tipoEnergia;
        idCliente = this.state.propuestasListado[indexPropuesta].T_Titular.NIF;
        cliente =
          this.state.propuestasListado[indexPropuesta].T_Titular.NombreTitular +
          " " +
          this.state.propuestasListado[indexPropuesta].T_Titular
            .Apellido1Titular;
        tipoDocumento = "P";
      }
      var idPropuestaEvento = value;
      var propuestaNombreEvento = propuesta;

      eventoAux["tipoEnergia"] = tipoEnergia;
      eventoAux["tipoDocumento"] = tipoDocumento;
      eventoAux["NIF"] = value;
      eventoAux["nombreCliente"] = cliente;

      this.setState({
        propuestaIdEvento: idPropuestaEvento,
        propuestaNombreEvento: propuestaNombreEvento,
        propuestaFechaInicioEvento: fechaPropuesta,
        tipoEnergia: tipoEnergia,
        tipoDocumento: tipoDocumento,
        eventoAux: eventoAux,
      });
    }

    if (event.target.name === "IdContrato") {
      let indexPropuesta = this.state.contratosListado.findIndex(
        (object) => object.IdContrato === value
      ); // 👉️ 1

      if (indexPropuesta !== -1) {
        propuesta = this.state.contratosListado[indexPropuesta].nombreOferta;
        fechaPropuesta =
          this.state.contratosListado[indexPropuesta].fechaInicioContrato;
        tipoEnergia = this.state.contratosListado[indexPropuesta].tipoEnergia;
        idCliente = this.state.contratosListado[indexPropuesta].T_Titular.NIF;
        cliente =
          this.state.contratosListado[indexPropuesta].T_Titular.NombreTitular +
          " " +
          this.state.contratosListado[indexPropuesta].T_Titular
            .Apellido1Titular;

        tipoDocumento = "C";
      }
      var idPropuestaEvento = value;
      var propuestaNombreEvento = propuesta;
      eventoAux["tipoEnergia"] = tipoEnergia;
      eventoAux["tipoDocumento"] = tipoDocumento;
      eventoAux["NIF"] = value;
      eventoAux["nombreCliente"] = cliente;

      this.setState({
        propuestaIdEvento: idPropuestaEvento,
        propuestaNombreEvento: propuestaNombreEvento,
        propuestaFechaInicioEvento: fechaPropuesta,
        tipoEnergia: tipoEnergia,
        tipoDocumento: tipoDocumento,
        eventoAux: eventoAux,
      });
    }

    if (
      event.target.name == "IdOferta" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      eventoAux["tipoEnergia"] = "";
      eventoAux["tipoDocumento"] = "";
      this.setState({
        contratosListDisabledEvento: false,
      });
    } else if (
      name == "IdOferta" &&
      (value || value.length > 0 || value !== "")
    ) {
      this.setState({
        contratosListDisabledEvento: true,
      });
    }

    if (
      event.target.name == "IdContrato" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      eventoAux["tipoEnergia"] = "";
      eventoAux["tipoDocumento"] = "";
      this.setState({
        propuestasListDisabledEvento: false,
      });
    } else if (
      name == "IdContrato" &&
      (value || value.length > 0 || value !== "")
    ) {
      this.setState({
        propuestasListDisabledEvento: true,
      });
    }

    this.setState({
      eventoAux: eventoAux,
    });

    if (camposBusqueda.includes(name)) {
      this.QueryPropuestas(eventoAux);
    }
    if (camposBusquedaContrato.includes(name)) {
      this.QueryContratos(eventoAux);
    }
  };

  onChangeModalEventoClick = (eventClickInfo, boton) => {
    var eventoAux = { ...this.state.eventoAux };

    let estado = "";
    let idEstado = "";

    if (boton == "bg-info") {
      estado = "INFORMACION";
      idEstado = "30";
    } else if (boton == "bg-warning") {
      estado = "PENDIENTE";
      idEstado = "40";
    } else if (boton == "bg-danger") {
      estado = "INCIDENCIA";
      idEstado = "50";
    } else if (boton == "bg-success") {
      estado = "OTROS";
      idEstado = "60";
    } else if (boton == "bg-primary") {
      estado = "CERRADO";
      idEstado = "90";
    }

    eventClickInfo.persist();
    eventoAux["radios"] = boton;
    eventoAux["estado"] = estado;
    eventoAux["idEstado"] = idEstado;

    this.setState({
      eventoAux: eventoAux,
      estadoDescripcion: estado,
    });
  };

  handleEventClick = (eventClickInfo) => {
    let estadoDescripcion = this.state.eventoAux.estado
      ? this.state.eventoAux.estado
      : "";
    let estadoDescripcionDato = eventClickInfo.event
      ? eventClickInfo.event.extendedProps.estado
      : estadoDescripcion;

    this.setState({
      modalChange: true,
      eventId: eventClickInfo.event.id,
      eventTitle: eventClickInfo.event.title,
      eventDescription: eventClickInfo.event.extendedProps.description,
      municipioEventoDescripcion:
        eventClickInfo.event.extendedProps.ayuntamiento,
      comercializadoraEventoDescripcion: eventClickInfo.event.extendedProps
        .empresa
        ? eventClickInfo.event.extendedProps.empresa
        : "Sin empresa",
      nifEvento: eventClickInfo.event.extendedProps.nif,
      empresaEvento: eventClickInfo.event.extendedProps.empresa,
      fechaDesdeEvento: moment(eventClickInfo.event.start).format("DD-MM-YYYY"),
      fechaHastaEvento: moment(eventClickInfo.event.end).format("DD-MM-YYYY"),
      radios: eventClickInfo.event.radios
        ? eventClickInfo.event.radios
        : eventClickInfo.event.classNames[0],
      estadoDescripcion: estadoDescripcionDato,
      event: eventClickInfo.event,
      classnames: eventClickInfo.event.classNames[0]
        ? eventClickInfo.event.classNames[0]
        : "",
      clienteModal: eventClickInfo.event.extendedProps.nombreCliente
        ? eventClickInfo.event.extendedProps.nombreCliente
        : "NO DEFINIDO",
      propuestaModal: eventClickInfo.event.extendedProps.propuestaIdEvento
        ? eventClickInfo.event.extendedProps.propuestaIdEvento
        : "NO DEFINIDO",
    });
  };

  //////////////////////////////////////////////////////////////////////////////

  handleSelect = (arg) => {
    const start = new Date(arg.startStr).toISOString();
    const end = moment(start).add(1, "hours").toISOString();

    this.setState({
      modalAdd: true,
      startDate: start,
      endDate: end,
      radios: "bg-info",
    });
  };

  //////////////////////////////////////////////////////////////////////////////////

  handleSelectDrop = (arg) => {
    var eventId = arg.event.id;
    var eventStart = arg.event.start;
    var eventEnd = arg.event.end;
    var event = arg.event;
    var idCambio = "";
    var newEvents = this.state.events.map((prop, key) => {
      if (prop.id + "" === eventId + "") {
        //this.state.event.remove();
        idCambio = prop.id;
        return {
          ...prop,
          start: eventStart,
          end: eventEnd,
        };
      } else {
        return prop;
      }
    });

    newEvents.map((prop, key) => {
      if (prop.id + "" === idCambio + "") {
        this.updatecalendarioList(prop);
      }
    });

    this.setState({
      events: newEvents,
      radios: "bg-info",
      eventTitle: undefined,
      eventDescription: undefined,
      eventId: undefined,
      event: undefined,
    });
  };

  addNewEvent = () => {

    if (
      this.state.eventoAux.comercial &&
      this.state.eventoAux.radios &&
      this.state.eventTitle
    ) {
      const eventoAux: any = this.state.eventoAux;

      let calendarEvents = [...this.state.events];
      const user: any = localStorage.getItem("user");
      var datosUser: any = [];
      if (user) {
        datosUser = JSON.parse(user);
        //this.setState({ user: parsed });
      }

      var iduser = eventoAux.idComercial;
      let identificador = uuid();
      let title = this.state.eventTitle;
      let start = this.state.startDate;
      let end = this.state.endDate;
      let className = this.state.radios;
      let id = identificador;
      let tipoDocumento = eventoAux.tipoDocumento;
      let tipoEnergia = eventoAux.tipoEnergia;
      let comercial = eventoAux.comercial;
      let idCliente = eventoAux.NIF;
      let nombreCliente = eventoAux.nombreCliente;
      //let propuestaEvento = this.state.propuestaEvento
      let propuestaIdEvento = this.state.propuestaIdEvento;
      let propuestaNombreEvento = this.state.propuestaNombreEvento;
      let propuestaFechaInicioEvento = this.state.propuestaFechaInicioEvento;
      let description = this.state.eventDescription
        ? this.state.eventDescription
        : "Sin Descripción";
      let estado = eventoAux.estado ? eventoAux.estado : "INFORMACION";
      let idEstado = eventoAux.idEstado ? eventoAux.idEstado : "30";

      let nif = this.state.nifEvento;
      let empresa = this.state.empresaEvento;

      calendarEvents.push({
        title: this.state.eventTitle,
        start: this.state.startDate,
        end: this.state.endDate,
        className: this.state.radios,
        id: identificador,
        description: description,
        allDay: true,
        extendedProps: {
          idComercial: iduser,
          comercial: comercial,
          tipoDocumento: tipoDocumento,
          tipoEnergia: tipoEnergia,
          idCliente: idCliente,
          nombreCliente: nombreCliente,
          propuestaIdEvento: propuestaIdEvento,
          propuestaNombreEvento: propuestaNombreEvento,
          propuestaFechaInicioEvento: propuestaFechaInicioEvento,
          estado: estado,
          idEstado: idEstado,
        },
      });

      this.setState({ events: calendarEvents });

      this.insertcalendarioList(
        title,
        start,
        end,
        className,
        id,
        description,
        iduser,
        comercial,
        tipoDocumento,
        tipoEnergia,
        idCliente,
        nombreCliente,
        propuestaIdEvento,
        propuestaNombreEvento,
        propuestaFechaInicioEvento,
        estado,
        idEstado
      );

      this.setState({
        modalAdd: false,
        startDate: undefined,
        endDate: undefined,
        radios: "bg-info",
        eventTitle: undefined,
        codifoIneEvento: null,
        municipioEvento: null,
        nifEvento: null,
        empresaEvento: null,
      });
    } else {
      this.warningAlertEvent();
    }
  };

  handleChangeDateFilter = (value, formattedValue, id) => {
    var formData = { ...this.state.filters };

    const name = id;
    var valueDay = formattedValue;
    if (name == "eventoDesde") {
      this.setState({ eventoDesde: value });
      this.setState({
        buscarButtonDisabled: false,
      });
    }
    if (name == "eventoHasta") {
      this.setState({ eventoHasta: value });
      this.setState({
        buscarButtonDisabled: false,
      });
    }
    formData[name] = value;
    this.setState({ filters: formData });
  };

  //////////////////////////////////////////////////////////////////////////////////////7

  hideAlert = () => {
    this.setState({
      alert: null,
    });
  };

  warningAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Error en la base de datos"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          Existe un error en la Base de datos.
        </ReactBSAlert>
      ),
    });
  };

  warningAlertNIF = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="No existen registros que cumplan los requisitos"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          Revise los requisitos introducidos
        </ReactBSAlert>
      ),
    });
  };

  warningAlertFiltros = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Existen campos obligatorios sin información"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          Revise los datos introducidos
        </ReactBSAlert>
      ),
    });
  };

  warningAlertEvent = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Existen campos obligatorios sin información"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          Debe introducir los datos de agente comercial, título y estado del
          evento a generar
        </ReactBSAlert>
      ),
    });
  };

  successAlert = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="Correcto"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="success"
          confirmBtnText="Ok"
          btnSize=""
        >
          Comercial guardado correctamente
        </ReactBSAlert>
      ),
    });
  };

  errorDB = () => {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Existe un problema con el servidor"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          Existe un problema con el servidor. Si persite este error, por favor,
          contacte con el área de soporte
        </ReactBSAlert>
      ),
    });
  };

  //////////////////////////////////////////////////////////////////////////////////

  fetchComercial = async () => {
    var companyIdUser = Number(this.state.companyIdUser);
    var user = this.state.userId.toString();
    var CIF = this.state.filters.cifSearch;
    var nombre = this.state.filters.nombreSearch;
    var apellidos = this.state.filters.apellidoSearch;

    var dataFilters = {
      idCompany: companyIdUser,
      cups: "",
      Usuario: "",
      NIFComercial: CIF,
      nombreComercial: nombre,
      apellido1Comercial: apellidos,
    };

    const valores = JSON.stringify(dataFilters);
    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };

    let direccionFile =
      "https://datapi.psgestion.es/comercial/listado?id=" +
      companyIdUser +
      "&user=" +
      user;

    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        if (result.data.rows.length > 0) {
          let data = result.data.rows;
          this.setState({ ComercialDetailTotal: result.data.rows });
        } else {
          this.warningAlertNIF();
        }
      })
      .catch((error) => {
        console.log("Failure");
        //this.warningAlertDB()
        this.warningAlert();
      });
  };

  onChangeFieldSearch = (event) => {
    event.persist();
    const name = event.target.name;
    let value = event.target.value;
    //var filters = this.state.filters;
    var filters = { ...this.state.filters };
    let errorsData = { ...this.state.errores };

    if (
      event.target.name == "comercial" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      errorsData["comercial"] = false;
      filters["comercial"] = value;
    } else if (
      name == "comercial" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsData["comercial"] = true;
      filters["comercial"] = value;
    }

    if (
      event.target.name == "estado" &&
      (!value || value.length == 0 || value == "" || value == "00")
    ) {
      errorsData["estado"] = false;
    } else if (
      name == "estado" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsData["estado"] = true;
    }

    if (
      event.target.name == "codeComercializadoraGas" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      errorsData["codeComercializadoraGas"] = false;
      filters["codeComercializadoraGas"] = value;
      this.setState({
        comerListDisabled: false,
      });
    } else if (
      name == "codeComercializadoraGas" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsData["codeComercializadoraGas"] = true;
      filters["codeComercializadoraGas"] = value;
      this.setState({
        comerListDisabled: true,
      });
    }

    if (
      event.target.name == "codeComercializadora" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      errorsData["codeComercializadora"] = false;
      filters["codeComercializadora"] = value;
      this.setState({
        comerGasListDisabled: false,
      });
    } else if (
      name == "codeComercializadora" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsData["codeComercializadora"] = true;
      filters["codeComercializadora"] = value;
      this.setState({
        comerGasListDisabled: true,
      });
    }

    if (
      event.target.type === "select-one" &&
      (value === "0" || value === "00")
    ) {
      //delete setFilters[name];
      value = "";
    }

    if (value === "0" || value === null || value === "00") {
      //delete setFilters[name];
      value = "";
    }

    filters[name] = value;
    this.setState({
      filters: filters,
      errores: errorsData,
    });
  };

  onChangeFieldEvento = (event) => {
    event.persist();
    const name = event.target.name;
    let value = event.target.value;
    var eventoAux = { ...this.state.eventoAux };
    let errorsDataEvento = { ...this.state.errores };
    let comercial = "";

    const camposBusqueda = [
      "idComercial",
      "codeComercializadoraGas",
      "codeComercializadora",
    ];

    if (
      event.target.name == "idComercial" &&
      (!value || value.length == 0 || value == "" || value == "0")
    ) {
      errorsDataEvento["comercial"] = false;
      eventoAux["comercial"] = "";
      eventoAux["idComercial"] = "";
    } else if (
      name == "idComercial" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsDataEvento["comercial"] = true;

      let indexComercial = this.state.usuariosPropuestas.findIndex(
        (object) => object.id === Number(value)
      ); // 👉️ 1

      if (indexComercial !== -1) {
        comercial =
          this.state.usuariosPropuestas[indexComercial].first_name +
          " " +
          this.state.usuariosPropuestas[indexComercial].last_name;
      }

      eventoAux["comercial"] = comercial;
      eventoAux["idComercial"] = value;
    }

    if (
      event.target.name == "estado" &&
      (!value || value.length == 0 || value == "" || value == "00")
    ) {
      errorsDataEvento["estado"] = false;
    } else if (
      name == "estado" &&
      (value || value.length > 0 || value !== "")
    ) {
      errorsDataEvento["estado"] = true;
    }

    if (event.target.type === "select-one" && (value == "0" || value == "00")) {
      value = "";
    }

    if (value == "0" || value == null || value == "00") {
      //delete setFilters[name];
      value = "";
    }

    eventoAux[name] = value;

    if (camposBusqueda.includes(name)) {
      this.QueryPropuestas(eventoAux);
      this.QueryContratos(eventoAux);
    }

    this.setState({
      eventoAux: eventoAux,
    });
  };

  QueryPropuestas = async (eventoAux) => {
    let isLoading = true;
    const isSearching = true;

    //  const isSearching = true;
    this.setState({ isLoading, isSearching });

    const usuario: any = JSON.parse(
      JSON.stringify(this.state.UserStore["data"])
    );
    const companyId = Number(usuario.companyId);

    //const companyId = this.state.companyIdUser.toString()
    const userId = "-1";
    var datos: any = eventoAux;
    var codeComercializadora = "";

    if (!datos.codeComercializadora && datos.codeComercializadoraGas) {
      codeComercializadora = datos.codeComercializadoraGas;
    } else if (!datos.codeComercializadoraGas && datos.codeComercializadora) {
      codeComercializadora = datos.codeComercializadora;
    }

    if (this.state.codegas != "" && !this.state.codeele) {
      codeComercializadora = this.state.codegas;
    }
    if (this.state.codeele != "" && !this.state.codegas) {
      codeComercializadora = this.state.codeele;
    }

    if (this.state.codeele == "" && this.state.codegas == "") {
      codeComercializadora = "";
    }

    var userIdAux = this.state.userId.toString();
    var userQuery = this.state.userId.toString();

    if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      Number(datos.idComercial) != Number(this.state.userId) &&
      (datos.idComercial !== "" || datos.idComercial !== null)
    ) {
      userQuery = datos.idComercial;
    } else if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      Number(datos.idComercial) == Number(this.state.userId)
    ) {
      userQuery = datos.idComercial;
    } else if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      (datos.idComercial == "" || datos.idComercial == null)
    ) {
      userQuery = "";
    } else if (this.state.userGroupId > 500) {
      userQuery = this.state.userId.toString();
    }

    var dataFilters = {
      Usuario: userQuery,
      idComercializadora: codeComercializadora,
      esAprobada: "",
      NIF: datos.NIF,
    };
    var contratoDato: any = [];

    var valores = JSON.stringify(dataFilters);
    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/propuesta/listadomulti?id=" +
      companyId +
      "&user=" +
      userId;

    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        let data = result.data.rows;
        this.setState({
          propuestasListado: data,
          propuestaFechaInicioEvento: "",
          propuestaNombreEvento: "",

          setPending: false,
        });
      })
      .catch((error) => {
        console.log("Failure ");
        this.errorDB();
      });
  };

  QueryContratos = async (eventoAux) => {
    let isLoading = true;
    const isSearching = true;

    //  const isSearching = true;
    this.setState({ isLoading, isSearching });

    const usuario: any = JSON.parse(
      JSON.stringify(this.state.UserStore["data"])
    );
    const companyId = Number(usuario.companyId);

    //const companyId = this.state.companyIdUser.toString()
    const userId = "-1";
    var datos: any = eventoAux;
    var codeComercializadora = "";

    if (!datos.codeComercializadora && datos.codeComercializadoraGas) {
      codeComercializadora = datos.codeComercializadoraGas;
    } else if (!datos.codeComercializadoraGas && datos.codeComercializadora) {
      codeComercializadora = datos.codeComercializadora;
    }

    if (this.state.codegas != "" && !this.state.codeele) {
      codeComercializadora = this.state.codegas;
    }
    if (this.state.codeele != "" && !this.state.codegas) {
      codeComercializadora = this.state.codeele;
    }

    if (this.state.codeele == "" && this.state.codegas == "") {
      codeComercializadora = "";
    }

    var userIdAux = this.state.userId.toString();
    var userQuery = this.state.userId.toString();

    if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      Number(datos.idComercial) != Number(this.state.userId) &&
      (datos.idComercial !== "" || datos.idComercial !== null)
    ) {
      userQuery = datos.idComercial;
    } else if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      Number(datos.idComercial) == Number(this.state.userId)
    ) {
      userQuery = datos.idComercial;
    } else if (
      (this.state.userGroupId == 1000 || this.state.userGroupId == 500) &&
      (datos.idComercial == "" || datos.idComercial == null)
    ) {
      userQuery = "";
    } else if (this.state.userGroupId > 500) {
      userQuery = this.state.userId.toString();
    }

    var dataFilters = {
      Usuario: userQuery,
      idComercializadora: codeComercializadora,
      esAprobada: "",
      NIF: datos.NIF,
    };
    var contratoDato: any = [];

    var valores = JSON.stringify(dataFilters);
    const headers = {
      Authorization: "Bearer my-token",
      "My-Custom-Header": "foobar",
      "x-api-key":
        "$2y$10$bcT1Ukm4V/6/z5GvitZv0unu8I91mpixuwUO6z5CyEGev9DDDY28W",
    };
    let direccionFile =
      "https://datapi.psgestion.es/contrato/listadomulti?id=" +
      companyId +
      "&user=" +
      userId;

    await axios
      .get(direccionFile, { headers, params: { valores } })
      .then((result) => {
        let data = result.data.rows;
        this.setState({
          contratosListado: data,
          propuestaFechaInicioEvento: "",
          propuestaNombreEvento: "",

          setPending: false,
        });
      })
      .catch((error) => {
        console.log("Failure ");
        this.errorDB();
      });
  };

  //////////////////////////////////////////////////////////////////////////

  consultarEventosBoton(props) {

    let existenErrores = Object.keys(this.state.errores).some(
      (k) => !this.state.errores[k]
    );

    if (existenErrores == true) {
      this.warningAlertFiltros();
    } else {
      this.getcalendarioList();
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  showFiltersToggle = () => {
    const showFilters = !this.state.showFilters;

    this.setState({ showFilters });
  };

  ///////////////////////////////////////////////////////////////////////////////////////

  getFilterIcon = () => {
    return this.state.showFilters ? "ni-bold-up" : "ni-bold-down";
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////

  clearForm = () => {
    const filters = {};
    this.setState({
      filters: {
        nombreSearch: "",
        cifSearch: "",
        apellidoSearch: "",
      },
      buscarButtonDisabled: true,
      ComercialSeleccionado: false,
      ComercialDetailTotal: [],
      toggledClearRows: !this.state.toggledClearRows,
      saveComercialButtonDisabled: true,
      updateComercialButtonDisabled: true,
      createdAt: "",
      fechaBaja: "",
    });

    this.formRef.current.reset();
  };

  handleChangeDate = (value, formattedValue, id) => {
    const name = id;
    var valueDay = formattedValue;
    var valorFechaFormateado = valueDay.split("-").reverse().join("-");

    if (name == "createdAt") {
      this.setState({
        updateDataComercial: true,
        createdAt: value,
        saveComercialButtonDisabled: true,
        updateComercialButtonDisabled: false,
      });
    }
    if (name == "fechaBaja") {
      this.setState({
        updateDataComercial: true,
        fechaBaja: value,
        saveComercialButtonDisabled: true,
        updateComercialButtonDisabled: false,
      });
    }
  };

  handleClearRows = () => {
    this.setState({ toggledClearRows: !this.state.toggledClearRows });
  };

  tipoSeleccionUsuario = (props: any) => {
    const userId = props.userId;
    const userGroupId = Number(props.userGroupId);

    //<></>

    if (userGroupId == 1000 || userGroupId == 500) {
      return (
        <React.Fragment>
          <Label className="form-control-label" htmlFor="comercial">
            Agente Comercial
          </Label>
          <Input
            className="form-control-alternative new-event--title"
            type="select"
            defaultValue={"DEFAULT"}
            name="idComercial"
            id="idComercial"
            onChange={this.onChangeFieldEvento}
          >
            <option value="">Selecciona un comercial... </option>
            {this.state.usuariosPropuestas.map((item: any, key) => (
              <option key={key} value={item.id}>
                {item.last_name} {item.first_name}
              </option>
            ))}
          </Input>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Label className="form-control-label" htmlFor="idComercial">
            Agente Comercial
          </Label>
          <Input
            className="form-control-alternative new-event--title"
            value={
              this.state.eventoAux.comercial
                ? this.state.eventoAux.comercial
                : "SIN AGENTE"
            }
            name="nombre"
            id="nombre"
          ></Input>
        </React.Fragment>
      );
    }
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////

  render() {
    const eventoDesde = this.state.eventoDesde;
    const eventoHasta = this.state.eventoHasta;

    if (this.state.userGroupId == 1000 || this.state.userGroupId == 500) {
      return (
        <>
          <Header title={"Información Eventos"} />
          <Container className=" mt--7" fluid>
            <Card className="mb-4">
              <CardHeader>
                <Button
                  onClick={this.showFiltersToggle}
                  size="sm"
                  className="float-right"
                >
                  <i className={"ni " + this.getFilterIcon()} />
                </Button>
                <h3 className="mb-0">Filtrar</h3>
              </CardHeader>
              <Collapse isOpen={this.state.showFilters}>
                <CardBody>
                  <Form innerRef={this.formRef}>
                    <Row>
                      <Col lg="auto">
                        <Label
                          className="form-control-label"
                          htmlFor="comercial"
                        >
                          AGENTE COMERCIAL
                        </Label>
                        <Input
                          type="select"
                          defaultValue={"DEFAULT"}
                          name="comercial"
                          id="comercial"
                          onChange={this.onChangeFieldSearch}
                        >
                          <option value="">Selecciona un comercial... </option>
                          {this.state.usuariosPropuestas.map(
                            (item: any, key) => (
                              <option key={key} value={item.id}>
                                {item.last_name} {item.first_name}
                              </option>
                            )
                          )}
                        </Input>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="3" lg="3">
                        <FormGroup>
                          <Label
                            className=" form-control-label text-primary"
                            htmlFor="estado"
                          >
                            ESTADO
                          </Label>
                          <Input
                            type="select"
                            defaultValue={"DEFAULT"}
                            name="estado"
                            id="estado"
                            onChange={this.onChangeFieldSearch}
                          >
                            <option value="">Selecciona un estado... </option>
                            {this.state.estadosEvento.map((item: any, key) => (
                              <option key={key} value={item.idEstado}>
                                {item.estado}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md="2">
                        <FormGroup>
                          <Label className="form-control-label">DESDE</Label>
                          <DatePicker
                            id="eventoDesde"
                            value={eventoDesde}
                            onChange={(v, f) =>
                              this.handleChangeDateFilter(v, f, "eventoDesde")
                            }
                            instanceCount={1}
                            dateFormat={"DD-MM-YYYY"}
                            dayLabels={spanishDayLabels}
                            monthLabels={spanishMonthLabels}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="2">
                        <FormGroup>
                          <Label className="form-control-label">HASTA</Label>
                          <DatePicker
                            id="eventoHasta"
                            value={eventoHasta}
                            onChange={(v, f) =>
                              this.handleChangeDateFilter(v, f, "eventoHasta")
                            }
                            instanceCount={1}
                            dateFormat={"DD-MM-YYYY"}
                            dayLabels={spanishDayLabels}
                            monthLabels={spanishMonthLabels}
                          />
                        </FormGroup>
                      </Col>

                      <Col className="text-right">
                        <Button onClick={this.clearForm}>
                          <i className={"ni ni-fat-remove"} /> Limpiar
                        </Button>
                        <Button
                          type="button"
                          color="primary"
                          onClick={() => {
                            this.consultarEventosBoton(this.state.errores);
                          }}
                        >
                          <i className={"bi bi-search"} /> Buscar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Collapse>
            </Card>
          </Container>

          <Container fluid>
            <Card className="card-calendar">
              <CardBody className="p-0">
                <FullCalendar
                  headerToolbar={{
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                  }}
                  themeSystem={"bootstrap"}
                  plugins={[interaction, dayGridPlugin, timeGridPlugin]}
                  selectable={true}
                  editable={true}
                  locale={esLocale}
                  events={this.state.events}
                  eventClick={this.handleEventClick}
                  select={this.handleSelect}
                  displayEventEnd={true}
                  eventDrop={this.handleSelectDrop}
                  showNonCurrentDates={false}
                //events= {this.state.events}
                //events={() => this.dataFecha()}
                />
              </CardBody>
            </Card>

            <Modal
              isOpen={this.state.modalAdd}
              toggle={() => this.setState({ modalAdd: false })}
              className="modal-dialog-centered modal-secondary"
            >
              <div className="modal-body">
                <form className="new-event--form">
                  <this.tipoSeleccionUsuario
                    userId={this.state.userId}
                    userGroupId={this.state.userGroupId}
                  />
                  <FormGroup>
                    <label className="form-control-label">Titulo Evento</label>
                    <Input
                      className="form-control-alternative new-event--title"
                      placeholder="Título evento"
                      type="text"
                      onChange={(e) =>
                        this.setState({ eventTitle: e.target.value })
                      }
                    />
                  </FormGroup>
                  <Row>
                    <Col lg="auto">
                      <FormGroup>
                        <Label className="form-control-label" for="IdOferta">
                          Propuesta Evento
                        </Label>
                        <Input
                          type="select"
                          defaultValue={"DEFAULT"}
                          name="IdOferta"
                          id="IdOferta"
                          onChange={this.onChangeModalEvento}
                          disabled={this.state.propuestasListDisabledEvento}
                        >
                          <option value="">Selecciona una propuesta... </option>
                          {this.state.propuestasListado.map(
                            (item: any, key) => (
                              <option key={key} value={item.IdOferta}>
                                {item.IdOferta}{" "}
                              </option>
                            )
                          )}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="auto">
                      <FormGroup>
                        <Label className="form-control-label" for="IdContrato">
                          Contrato Evento
                        </Label>
                        <Input
                          type="select"
                          defaultValue={"DEFAULT"}
                          name="IdContrato"
                          id="IdContrato"
                          onChange={this.onChangeModalEvento}
                          disabled={this.state.contratosListDisabledEvento}
                        >
                          <option value="">Selecciona un contrato... </option>
                          {this.state.contratosListado.map((item: any, key) => (
                            <option key={key} value={item.IdOferta}>
                              {item.IdOferta}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="auto">
                      <FormGroup>
                        <Label className="form-control-label" for="IdCliente">
                          Cliente
                        </Label>
                        <Input
                          type="select"
                          defaultValue={"DEFAULT"}
                          name="IdCliente"
                          id="IdCliente"
                          onChange={this.onChangeModalEvento}
                        >
                          <option value="">Selecciona un cliente... </option>
                          {this.state.clientesPropuestas.map(
                            (item: any, key) => (
                              <option key={key} value={item.NIF}>
                                {item.NIF} - {item.NombreTitular}{" "}
                                {item.Apellido1Titular}
                              </option>
                            )
                          )}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="auto">
                      <FormGroup className="mb-0">
                        <label className="form-control-label d-block mb-3">
                          Color Estados
                        </label>
                        <ButtonGroup
                          className="btn-group-toggle btn-group-colors event-tag"
                          data-toggle="buttons"
                        >
                          <Button
                            className={classnames("bg-info", {
                              active: this.state.radios === "bg-info",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-info" },
                                this.onChangeModalEventoClick(e, "bg-info")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-warning", {
                              active: this.state.radios === "bg-warning",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-warning" },
                                this.onChangeModalEventoClick(e, "bg-warning")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-danger", {
                              active: this.state.radios === "bg-danger",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-danger" },
                                this.onChangeModalEventoClick(e, "bg-danger")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-success", {
                              active: this.state.radios === "bg-success",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-success" },
                                this.onChangeModalEventoClick(e, "bg-success")
                              )
                            }
                          />
                        </ButtonGroup>
                      </FormGroup>
                    </Col>
                    <Col lg="auto">
                      <FormGroup>
                        <label className="form-control-label">Estado</label>
                        <Input
                          className="form-control-alternative new-event--title"
                          placeholder="Título evento"
                          type="text"
                          defaultValue={this.state.eventoAux.estado}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <label className="form-control-label">Descripción</label>
                    <Input
                      className="form-control-alternative edit-event--description textarea-autosize"
                      placeholder="Descripción del evento"
                      type="textarea"
                      defaultValue={this.state.eventDescription}
                      onChange={(e) =>
                        this.setState({ eventDescription: e.target.value })
                      }
                    />
                    <i className="form-group--bar" />
                  </FormGroup>

                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Fecha Propuesta/Contrato:{" "}
                      {this.state.propuestaFechaInicioEvento}
                    </label>
                  </FormGroup>
                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Nombre Propuesta: {this.state.propuestaNombreEvento}
                    </label>
                  </FormGroup>
                </form>
              </div>
              <div className="modal-footer">
                <Button
                  className="new-event--add"
                  color="primary"
                  type="button"
                  onClick={this.addNewEvent}
                >
                  Crear Evento
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  type="button"
                  onClick={() => this.setState({ modalAdd: false })}
                >
                  Cerrar
                </Button>
              </div>
            </Modal>
            <Modal
              isOpen={this.state.modalChange}
              toggle={() => this.setState({ modalChange: false })}
              className="modal-dialog-centered modal-secondary"
            >
              <div className="modal-body">
                <Form className="edit-event--form">
                  <FormGroup>
                    <label className="form-control-label">Título Evento</label>
                    <Input
                      className="form-control-alternative edit-event--title"
                      placeholder="Título evento"
                      type="text"
                      defaultValue={this.state.eventTitle}
                      onChange={(e) =>
                        this.setState({ eventTitle: e.target.value })
                      }
                    />
                  </FormGroup>

                  <Row>
                    <Col md="4">
                      <label className="form-control-label">Comienzo</label>
                      <Input
                        className="form-control-alternative edit-event--title"
                        placeholder="Comienzo evento"
                        type="text"
                        defaultValue={this.state.fechaDesdeEvento}
                        disabled={true}
                      />
                    </Col>

           {/*        <Col md="4">
                      <label className="form-control-label">Fin</label>
                      <Input
                        className="form-control-alternative edit-event--title"
                        placeholder="Fin evento"
                        type="text"
                        defaultValue={this.state.fechaHastaEvento}
                        disabled={true}
                      />
                    </Col> */}
                  </Row>
                  <Row>
                    <Col lg="auto">
                      <FormGroup className="mb-0">
                        <label className="form-control-label d-block mb-3">
                          Color Estados
                        </label>
                        <ButtonGroup
                          className="btn-group-toggle btn-group-colors event-tag"
                          data-toggle="buttons"
                        >
                          <Button
                            className={classnames("bg-info", {
                              active: this.state.radios === "bg-info",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-info" },
                                this.onChangeModalEventoClick(e, "bg-info")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-warning", {
                              active: this.state.radios === "bg-warning",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-warning" },
                                this.onChangeModalEventoClick(e, "bg-warning")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-danger", {
                              active: this.state.radios === "bg-danger",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-danger" },
                                this.onChangeModalEventoClick(e, "bg-danger")
                              )
                            }
                          />
                          <Button
                            className={classnames("bg-success", {
                              active: this.state.radios === "bg-success",
                            })}
                            color=""
                            type="button"
                            onClick={(e) =>
                              this.setState(
                                { radios: "bg-success" },
                                this.onChangeModalEventoClick(e, "bg-success")
                              )
                            }
                          />
                        </ButtonGroup>
                      </FormGroup>
                    </Col>
                    <Col lg="auto">
                      <FormGroup>
                        <label className="form-control-label">Estado</label>
                        <Input
                          className="form-control-alternative new-event--title"
                          placeholder="Título evento"
                          type="text"
                          value={this.state.estadoDescripcion}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <label className="form-control-label">Descripción</label>
                    <Input
                      className="form-control-alternative edit-event--description textarea-autosize"
                      placeholder="Descripción del evento"
                      type="textarea"
                      defaultValue={this.state.eventDescription}
                      onChange={(e) =>
                        this.setState({ eventDescription: e.target.value })
                      }
                    />
                    <i className="form-group--bar" />
                  </FormGroup>
                  <input className="edit-event--id" type="hidden" />
                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Fecha Propuesta/Contrato:{" "}
                      {this.state.propuestaFechaInicioEvento}
                    </label>
                  </FormGroup>
                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Nombre Propuesta: {this.state.propuestaNombreEvento}
                    </label>
                  </FormGroup>
                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Cliente: {this.state.clienteModal}
                    </label>
                  </FormGroup>
                  <FormGroup>
                    <label className="form-control-label d-block mb-3">
                      Propuesta/Contrato: {this.state.propuestaModal}
                    </label>
                  </FormGroup>
                </Form>
              </div>
              <div className="modal-footer">
                <Button color="primary" onClick={this.changeEvent}>
                  Actualizar
                </Button>
                <Button
                  color="danger"
                  onClick={() =>
                    this.setState({ modalChange: false }, () =>
                      this.deleteEventSweetAlert()
                    )
                  }
                >
                  Borrar
                </Button>
                <Button
                  className="ml-auto"
                  color="link"
                  onClick={() => this.setState({ modalChange: false })}
                >
                  Cerrar
                </Button>
              </div>
            </Modal>
            {this.state.alert}
          </Container>
        </>
      );
    } else {
      return (
        <>
          <Header
            title={
              "No tienes permisos para acceder a este apartado. Consulte con nuestro equipo comercial"
            }
          />
        </>
      );
    }
  }
}

export default withApollo(eventos);
